import React from 'react'
import Container from '@material-ui/core/Container';
import imgHero from '../../assets/imghero2.jpg';
import imgcasazen from '../../assets/galeriacz2.jpg';
import imglasoñada from '../../assets/galerials3.jpg';
import namaste from '../../assets/namaste.svg';
import casazen from '../../assets/casazen.svg';
import lasoñada from '../../assets/lasoñada.svg';
import BotonBox from '../BotonBox';



const Section2 = () => {
  return (
    <div className='section margtop indexSec noPadBot'>
        <Container className='relative flex flexCenter flexCol'>
          <div className="flex flexRow flexWrap col50">
            <div className='backDark shadow hoverScale'>
              <img className='logoBox' src={namaste} alt="Logo Namasté" />
              <h3 className='textCenter'>Entre Médanos y Mar</h3>
              <p className='textCenter relative pbox'>Una propuesta única frente al mar y en un marco natural único, con todo el confort de un proyecto pensado para una verdadera inmersión sensorial</p>
              <BotonBox className='hoverScale' text='Ver más' link='/namaste' />
            </div>
            <div>
            <img className='imgProyecto' src={imgHero} alt="Imágen Namasté" />

            </div>
          </div>

          
          <div className="flex flexRow flexWrap col50 reverse margtop">
            <div className='backDark shadow hoverScale'>
             <img className='logoBox' src={casazen} alt="Logo Casa Zen" />
              <h3 className='textCenter relative'>Conecta los sentidos</h3>
              <p className='textCenter relative pbox'>Un proyecto cuyo patio central como protagonista aporta a la vivienda gran luminosidad a cada uno de sus espacios, consagrando junto a su fondo vidriado un estrecho vínculo con el exterior</p>
              
              <BotonBox className='hoverScale' text='Ver más' link='/casazen' />
            </div>
            <div>
              <img className='imgProyecto' src={imgcasazen} alt="Imágen Casa Zen" />
            </div>
          </div>


          <div className="flex flexRow flexWrap col50 margtop">
            <div className='backDark shadow hoverScale'>
             <img className='logoBox' src={lasoñada} alt="Logo La Soñada" />
              <h3 className='textCenter relative'>La belleza de lo simple</h3>
              <p className='textCenter relative pbox'>Su diseño en forma de "L" permite a la vivienda repararse de los vientos fríos y húmedos y al mismo tiempo abrazar gran cantidad de luz generando frescura y confort a cada uno de sus ambientes</p>

              <BotonBox className='hoverScale' text='Ver más' link='/lasonada' />
            </div>
            <div>
              <img className='imgProyecto' src={imglasoñada} alt="Imágen La Soñada" />
            </div>
          </div>


        </Container>
    </div>
  )
}

export default Section2